'use client';
import JoyAlert, { AlertProps as JoyAlertProps } from '@mui/joy/Alert';
import { Button } from './Button';
import { Trans } from '@lingui/react';
import { Stack } from './Stack';
import { Box } from './Box';
import { ReactNode, useState } from 'react';

export type AlertProps = JoyAlertProps & {
  expandContent?: ReactNode;
};

export const Alert = ({ children, expandContent, ...props }: AlertProps) => {
  const [show, setShow] = useState(false);

  return (
    <JoyAlert
      {...props}
      endDecorator={
        expandContent ? (
          <Button variant="outlined" size="sm" onClick={() => setShow(!show)}>
            {show ? <Trans id="Close" /> : <Trans id="Read more" />}
          </Button>
        ) : (
          props.endDecorator
        )
      }
    >
      {expandContent ? (
        <Stack gap={2}>
          <Box>{children}</Box>
          {show && <Box>{expandContent}</Box>}
        </Stack>
      ) : (
        children
      )}
    </JoyAlert>
  );
};
